import { AbstractComponent } from '@/utils/sections/abstract-component';
import { register } from '@/utils/sections/registration';
import Swiper from 'swiper';
import { EffectFade, Pagination, Autoplay, Navigation, Mousewheel } from 'swiper/modules';

export class Gallery extends AbstractComponent {
  init() {
    const options = this.el.dataset.sliderOptions ? JSON.parse(this.el.dataset.sliderOptions) : {};

    const el = this.el.querySelector('.swiper');
    if (!el) {
      return;
    }

    const slidesCount = el.querySelectorAll('.swiper-slide').length;

    this.swiper = new Swiper(el, {
      slidesPerView: 1,
      modules: [EffectFade, Pagination, Autoplay, Navigation, Mousewheel],
      loop: slidesCount > 1,
      speed: 700,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      autoplay: {
        delay: 3000,
      },
      navigation: {
        nextEl: "[data-next]",
        prevEl: "[data-prev]",
      },
      pagination: {
        el: ".gallery__pagination",
      },
      ...options,
    });
  }
}

register('gallery', Gallery);
